module.exports = __webpack_public_path__ + "img/malfunction-indicator-off.258ce2bf.svg";